export * from './StyledFootr'
